import React from 'react';

const ScrollWrapper = ({ children }) => {
    return (
        <div className="flex-1 max-h-[65vh]" >
            <div className="w-full rounded-md overflow-hidden flex flex-col mt-4 h-full">
                <div className="flex-1 overflow-auto hide-scrollbar">
                    {children}
                </div>
            </div>
        </div>
    );
};


export default ScrollWrapper;